import { render } from "./BarChart.vue?vue&type=template&id=1d5ae66c&scoped=true&ts=true"
import script from "./BarChart.ts?vue&type=script&lang=ts"
export * from "./BarChart.ts?vue&type=script&lang=ts"

import "./BarChart.scss?vue&type=style&index=0&id=1d5ae66c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5ae66c"]])

export default __exports__